import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59ef5f28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scm-error-log" }
const _hoisted_2 = { class: "table-list" }
const _hoisted_3 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_created_user = _resolveComponent("created-user")!
  const _component_disabled_dev_user = _resolveComponent("disabled-dev-user")!
  const _component_dev_user_logs = _resolveComponent("dev-user-logs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_page, { fheader: { showCollapse: true } }, {
      fheader: _withCtx(({ collapse }) => [
        _createVNode(_component_el_form, {
          size: "default",
          ref: "queryForm",
          "label-width": "120px",
          model: _ctx.params,
          onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "开发者账号名",
              prop: "accountName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入开发者账号名",
                  modelValue: _ctx.params.accountName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.accountName) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "200",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "用户名称",
              prop: "userName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入用户名称",
                  modelValue: _ctx.params.userName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.userName) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "200",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "UDID",
              prop: "userUDID"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入UDID",
                  modelValue: _ctx.params.userUDID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.userUDID) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "200",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "用户来源"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择用户来源",
                      modelValue: _ctx.params.dataChannel,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.dataChannel) = $event)),
                      style: {"width":"100%"},
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APP_USER_SOURCE_LIST, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            collapse
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "在职状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择在职状态",
                      modelValue: _ctx.params.workState,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.workState) = $event)),
                      style: {"width":"100%"},
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WORK_STATUS_LIST, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              "label-width": "0",
              class: "margin-left-20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "default",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearch())),
                  onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 查询 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "default",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleReset()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 重置 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["model"])
      ]),
      header: _withCtx(() => [
        (_ctx.$has(_ctx.permissionConfig.CREATE))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: _ctx.handleCreated
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 创建用户 ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.$has(_ctx.permissionConfig.REFRESH_WORK_STATUS))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "default",
              onClick: _ctx.handleRefreshWorkStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 刷新在职状态数据 ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(({
          height
        }) => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: height,
            key: height,
            data: _ctx.tableData,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "accountId",
                label: "开发者账号ID",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "accountName",
                label: "开发者账号名",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "dataChannel",
                label: "用户来源",
                align: "center",
                width: "200"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.APP_USER_SOURCE_LIST, row.dataChannel)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "userName",
                label: "用户名称",
                align: "center",
                width: "200"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.userName) + " ", 1),
                  (row.workState === _ctx.WORK_STATUS_ENUM.RESIGN)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("离职")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "用户编码",
                align: "center",
                prop: "userCode",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                prop: "userUDID",
                label: "用户UDID",
                align: "center",
                width: "200"
              }),
              _createVNode(_component_el_table_column, {
                prop: "createMessage",
                label: "创建信息",
                align: "center",
                width: "300"
              }),
              _createVNode(_component_el_table_column, {
                prop: "isEnabled",
                label: "状态",
                align: "center",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.getEnumLabel(_ctx.APP_IS_ENABLED_LIST, row.isEnabled)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center",
                width: "250px",
                fixed: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.$has(_ctx.permissionConfig.UPDATE))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          class: "flex-1",
                          onClick: ($event: any) => (_ctx.handelUserEdit(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.isEnabled === 'YES' && _ctx.$has(_ctx.permissionConfig.ENABLE))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "text",
                          class: "flex-1 text-red",
                          onClick: ($event: any) => (_ctx.handleDisabled(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("停用")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.isEnabled === 'NO' && _ctx.$has(_ctx.permissionConfig.ENABLE))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "text",
                          class: "flex-1",
                          onClick: ($event: any) => (_ctx.handleEnable(row, _ctx.handleSearch))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("启用")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.$has(_ctx.permissionConfig.LOG))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 3,
                          type: "text",
                          class: "flex-1",
                          onClick: ($event: any) => (_ctx.handleShowLogs(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("操作记录")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.isEnabled === 'NO' && _ctx.$has(_ctx.permissionConfig.DELETE))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 4,
                          type: "text",
                          class: "flex-1 text-red",
                          onClick: ($event: any) => (_ctx.handleDel(row, _ctx.handleSearch))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["height", "data"])), [
            [_directive_loading, _ctx.tableLoading]
          ])
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%","padding-top":"10px"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              size: _ctx.params.pageSize,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "current-page", "size", "onSizeChange", "onCurrentChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_created_user, {
      visible: _ctx.createdUserVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createdUserVisible) = $event)),
      accountUserItem: _ctx.accountUserItem,
      accountList: _ctx.accountList,
      onHandleSearch: _ctx.handleSearch
    }, null, 8, ["visible", "accountUserItem", "accountList", "onHandleSearch"]),
    _createVNode(_component_disabled_dev_user, {
      visible: _ctx.disabledVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.disabledVisible) = $event)),
      accountUserItem: _ctx.accountUserItem,
      onHandleSearch: _ctx.handleSearch
    }, null, 8, ["visible", "accountUserItem", "onHandleSearch"]),
    _createVNode(_component_dev_user_logs, {
      visible: _ctx.logVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.logVisible) = $event)),
      logData: _ctx.gridData
    }, null, 8, ["visible", "logData"])
  ]))
}